import type { MergePurgeView } from '@annotations/mergePurgeView';

import { datastreamQueryKeys } from '@/common/query-keys';

export const reportQueryKeys = {
  mergePurge: {
    base: [...datastreamQueryKeys.base, 'merge-purge'] as const,
    report: (view: MergePurgeView, mailingId: number, version?: number) => {
      return [...reportQueryKeys.mergePurge.base, view, mailingId, version] as const;
    },
  },
};
